var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "about-video-outer-container",
      class: _vm.block.section_bg_color
    },
    [
      _c(
        "div",
        { staticClass: "about-inner-video-content-container" },
        [
          _c("div", { staticClass: "about-text-video-content-container" }, [
            _c("div", { staticClass: "about-video-text-container" }, [
              _vm.block.preheader.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "preheader about-video-preheader",
                      class: _vm.block.pre_heading_color
                    },
                    [_vm._v(_vm._s(_vm.block.preheader))]
                  )
                : _vm._e(),
              _vm.block.header.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "about-video-header h3",
                      class: _vm.block.heading_color
                    },
                    [_vm._v(_vm._s(_vm.block.header))]
                  )
                : _vm._e(),
              _vm.block.body_copy.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "body-md about-video-copy",
                      class: _vm.block.body_copy_color
                    },
                    [_vm._v(_vm._s(_vm.block.body_copy))]
                  )
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "about-video-container" }, [
            _c("iframe", {
              staticClass: "about-video-frame",
              attrs: {
                src: "https://www.youtube.com/embed/" + _vm.block.video_id,
                frameborder: "0",
                allow:
                  "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: ""
              }
            })
          ]),
          _vm.block.cta_layout.includes("button") &&
          _vm.block.cta_title.length > 0
            ? _c(
                "v-button",
                {
                  staticClass: "hero-banner__cta",
                  class: _vm.block.cta_layout,
                  attrs: { tag: "a", href: _vm.block.cta_link }
                },
                [_vm._v(_vm._s(_vm.block.cta_title))]
              )
            : _vm._e(),
          _vm.block.cta_layout.includes("link") &&
          _vm.block.cta_title.length > 0
            ? _c(
                "v-link",
                {
                  staticClass: "hero-banner__cta",
                  class: _vm.block.cta_layout,
                  attrs: { href: _vm.block.cta_link, tag: "a" }
                },
                [_vm._v(_vm._s(_vm.block.cta_title))]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }